if (!customElements.get("variant-dropdown-cp")) {
  customElements.define(
    "variant-dropdown-cp",

    class VariantDropdownCP extends HTMLElement {
      constructor() {
        super();
        /** @type {Variant[]} */
        this.variants = [];
      }

      connectedCallback() {
        this.productId = this.dataset.productId;
        const jsonElement = this.querySelector('[type="application/json"]');
        if (jsonElement) {
        this.variants = JSON.parse(
          jsonElement.innerHTML || '[]'
        );
        } else {
          this.variants = [];
        }

        // Variant quantities from sibling script (scoped to this product-card)
        /** @type {Map<string, number>} */
        this.variantQtyMap = new Map();
        const card = this.closest('product-card');
        const qtyEl = card ? card.querySelector('#variant-quantities') : null;
        if (qtyEl && qtyEl.textContent) {
          const parts = qtyEl.textContent.split('/').filter(Boolean);
          for (let i = 0; i < this.variants.length; i++) {
            const v = this.variants[i];
            const raw = parts[i] || '0';
            const qty = parseInt(raw.replace(/"/g, '')) || 0;
            this.variantQtyMap.set(v.id.toString(), qty);
          }
        }

        // Hidden variants plumbing
        /** @type {Set<string>} */
        this.hiddenVariantIdSet = new Set();
        const hiddenEl = this.querySelector('#hidden-variant-ids');
        if (hiddenEl && hiddenEl.textContent) {
          try {
            const ids = JSON.parse(hiddenEl.textContent);
            if (Array.isArray(ids)) {
              this.hiddenVariantIdSet = new Set(ids.map((id) => id.toString()));
            }
          } catch (e) {
            // no-op
          }
        }

        this.select = this.querySelector("select");
        this.filterOptions();
        if (this.select) {
          this.select.addEventListener("change", this.onChange.bind(this));
        }
      }

      filterOptions() {
        if (!this.select || !this.variants) return;
        const options = Array.from(this.select.options);
        options.forEach((opt) => {
          const v = this.variants.find((variant) => variant.title === opt.value);
          if (v && this.hiddenVariantIdSet && this.hiddenVariantIdSet.has(v.id.toString())) {
            opt.remove();
          }
        });
        if (this.select.options.length > 0) {
          // Initialize to first available (qty > 0) option when possible
          let chosenIndex = 0;
          for (let i = 0; i < this.select.options.length; i++) {
            const opt = this.select.options[i];
            const v = this.variants.find((variant) => variant.title === opt.value);
            if (v && this.variantQtyMap && this.variantQtyMap.get(v.id.toString()) > 0) {
              chosenIndex = i;
              break;
            }
          }
          this.select.selectedIndex = chosenIndex;
          this.onChange({ target: this.select });
        } else {
          // No visible variants for this product card
          messenger.emmit(messenger.topics.SET_THIS_CARD_BUTTON_TO_SOLD_OUT, {
            productId: this.productId,
          });
        }
      }

      onChange(e) {
        let selectedVariant = this.variants.find(
          (variant) => variant.title === e.target.value && !this.hiddenVariantIdSet.has(variant.id.toString())
        );
        if (!selectedVariant) {
          selectedVariant = this.variants.find(
            (variant) => !this.hiddenVariantIdSet.has(variant.id.toString())
          );
          if (!selectedVariant) {
            // nothing to do
            messenger.emmit(messenger.topics.SET_THIS_CARD_BUTTON_TO_SOLD_OUT, {
              productId: this.productId,
            });
            return;
          }
        }
        // console.log('selectedVariant', selectedVariant);

        messenger.emmit(messenger.topics.SET_VARIANT_INPUT_ON_PRODUCT_CARD, {
          productId: this.productId,
          variantId: selectedVariant.id.toString(),
        });
        messenger.emmit(messenger.topics.CHANGE_PRODUCT_CARD_IMAGE, {
          index: null,
          productId: this.productId,
          variantId: selectedVariant.id.toString(),
        });
      }
    }
  );
}
